import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import selectHelper from '../../../Helpers/selectHelper';
import UserService from '../../../Services/userService';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';

export default class FreelancerPaymentExportSearchParams extends SearchParamsBase {
  initialize() {
    let yearsToAdd = 1;

    this.FreelancerPaymentExportId = '';
    this.FreelancerInvoiceId = '';
    this.OfficeId = OfficeHelper.GetDefaultOfficeIds(UserService.GetOfficeIdOfLoggedInUser());
    this.PaymentMethod = '';
    this.Status = '';
    this.UserId = '';
    this.UseDateRange = false;
    this.StartDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addYearsToNowDate(yearsToAdd * -1));
    this.EndDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    {
      fieldName: 'FreelancerPaymentExportId',
      label: 'FreelancerPaymentExportId',
      className: 'col-3',
      type: InputTypesEnum.Number,
    },
    { fieldName: 'FreelancerInvoiceId', label: 'FreelancerInvoiceId', className: 'col-3', type: InputTypesEnum.Number },
    {
      fieldName: 'OfficeId',
      label: 'Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeOrGroupSelect,
      roleKey: 'Freelancer_inputfield_VendorAdminFinanceAdmin',
    },
    // {fieldName:"PaymentMethod",label:"PaymentMethod", className:"col-3", type: InputTypesEnum.Number},
    // {fieldName:"Status",label:"Status", className:"col-3", type: InputTypesEnum.Number},
    { fieldName: 'UserId', label: 'User', className: 'col-3', type: InputTypesEnum.UserSelect },
    { fieldName: 'UseDateRange', label: 'Use Date Range', className: 'col-3', type: InputTypesEnum.OnOff },
    {
      fieldName: 'StartDate',
      label: 'Start Date',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'EndDate',
      label: 'End Date',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'Status',
      label: 'Status',
      className: 'col-3',
      type: InputTypesEnum.Select,
      options: FreelancerPaymentExportSearchParams.getStatusSelectOptions(),
    },
    {
      fieldName: 'PaymentMethod',
      label: 'Payment Method',
      className: 'col-3',
      type: InputTypesEnum.Select,
      options: FreelancerPaymentExportSearchParams.getPaymentMethodSelectOptions(),
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'FreelancerPaymentExportSearchParams';

  //---------------------------

  static getStatusSelectOptions() {
    return selectHelper.generateSelectValues(['', 'Created', 'Exported']);
  }

  static getPaymentMethodSelectOptions() {
    return selectHelper.generateSelectValues([
      '',
      'AliPay',
      'BankTransfer',
      'PayNow',
      'PayPal',
      'Tipalti',
      'WesternUnion',
      'Wise',
    ]);
  }
}
